const cls = (input) => input.filter(Boolean).join(' ');

export default cls;
